module.exports = __webpack_public_path__ + "static/media/jorritvelzeboer.4c3d8162.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/jorritvelzeboer.webp
// module id = 578
// module chunks = 0